/* eslint-disable import/no-named-as-default */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import * as statusActions from 'actions/statusActions';
import * as userActions from 'actions/userActions';
import * as techInventoryActions from 'actions/techInventoryActions';
import SearchSelectMd from 'techComponents/SearchSelectMd';
import TechInventorySwap from 'equipmentComponents/TechInventorySwap';
import Footer from 'containers/Footer';
import { red500, green500 } from 'material-ui/styles/colors';
import Loading from 'components/layout/Loading';
import CompareArrowsIcon from 'material-ui/svg-icons/action/compare-arrows';

export class TransferEquipmentPage extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.findTech = this
            .findTech
            .bind(this);

        this.onFromTechIdChange = this
            .onFromTechIdChange
            .bind(this);

        this.onToTechIdChange = this
            .onToTechIdChange
            .bind(this);

        this.updateRecentSearches = this
            .updateRecentSearches
            .bind(this);

        this.recentSearchChanged = this
            .recentSearchChanged
            .bind(this);

        this.recentSearchOptions = [];
    }
    componentWillReceiveProps(nextProps) {
        const { techData } = nextProps;

        if (techData.getIn(['techSearch', 'topMatch'])) {
            const techUserId = techData.getIn(['techSearch', 'topMatch']);
            const inventoryLoading = techData.getIn(['techs', techUserId, 'inventory', 'loading']);
            const inventoryLoadingFinished = techData.getIn(['techs', techUserId, 'inventory', 'loadingFinished']);
            const shouldLoadInventory = !inventoryLoading && !inventoryLoadingFinished;

            if (techUserId && shouldLoadInventory) {

                techInventoryActions.getTechInventoryStarted({
                    isSelf: false
                }, techUserId);
            }
        }
        this.updateRecentSearches();
    }

    updateRecentSearches() {
        const { techData, user } = this.props;
        const currentUserId = user.get('userId');

        if (techData.getIn(['techSearch', 'techSearchResults'])) {
            const recentSearchs = techData
                .getIn(['techSearch', 'techSearchResults'])
                .keySeq()
                .toArray();

            this.recentSearchOptions = [];

            recentSearchs.forEach(function (userId) {
                if (userId && userId !== currentUserId) {

                    const techInfo = techData.getIn(['techs', userId]);

                    this
                        .recentSearchOptions
                        .push({
                            userId: userId,
                            techId: techInfo.getIn(['info', 'techId'])
                        });
                }
            }, this);
        }

    }

    recentSearchChanged(event, index, value) {
        const { userActions } = this.props;
        userActions.setTechSearchTopMatch(value);
    }

    findTech(event) {
        const { techData, userActions } = this.props;
        event.preventDefault();
        userActions.getTechInfoStarted(techData.getIn(['techSearch', 'searchCriteria']));
    }

    onFromTechIdChange(fromTechId) {
        const { userActions } = this.props;
        userActions.setTechSearchProperty(fromTechId);
    }

    onToTechIdChange(toTechId) {
        const { userActions } = this.props;
        userActions.setTechTransferToProperty(toTechId);
    }

    buildRecentSearches() {
        if (this.recentSearchOptions.length > 0) {
            return (<SearchSelectMd
                options={this.recentSearchOptions}
                useNullableFirstItem={true}
                labelText="Recent Searches"
                value={null}
                onChange={this.recentSearchChanged}
                style={{
                    color: "black"
                }} />);
        }
    }

    generateContent() {
        const { techData, user, techInventoryActions } = this.props;

        const isFieldAdmin = user.get('isFieldAdmin');

        const currentUserId = user.get('userId');
        const fromUserId = techData.getIn(['techSearch', 'topMatch']);
        const fromTech = techData.getIn(['techs', fromUserId]);
        const searchError = techData.getIn(['techSearch', 'error']);

        const inventoryLoading = techData.getIn(['techs', fromUserId, 'inventory', 'loading']);
        const inventoryLoadingFinished = techData.getIn(['techs', fromUserId, 'inventory', 'loadingFinished']);


        if (inventoryLoading && !inventoryLoadingFinished) {
            return (<Loading message="Loading..." isLoading={true} />);
        }

        let defaultMessage;
        if (searchError === "ajax error 404") {
            defaultMessage = "No Tech Found";
        } else if (searchError) {
            defaultMessage = searchError;
        }

        if (!fromUserId || !fromTech) {
            return (
                <h6>
                    {defaultMessage}
                </h6>
            );
        }

        const transferError = techData.getIn(['inventoryTransfer', 'error']);
        let transferErrorDisplay = null;
        if (transferError) {
            transferErrorDisplay = (
                <h5
                    className="center-align"
                    style={{
                        color: red500
                    }}>{transferError}</h5>
            );
        }
        const transferMessage = techData.getIn(['inventoryTransfer', 'message']);
        let transferMessageDisplay = null;
        if (transferMessage) {
            transferMessageDisplay = (
                <h5
                    className="center-align"
                    style={{
                        color: green500
                    }}>{transferMessage}</h5>
            );
        }

        if (fromUserId) {
            const inventory = techData.getIn(['techs', fromUserId, 'inventory']);

            const fromTechId = techData.getIn(['techs', fromUserId, 'info', 'techId']);
            let toTechId;

            if (isFieldAdmin) {
                toTechId = techData.getIn(['techSearch', 'transferToTechId']);
            } else {
                toTechId = techData.getIn(['techs', currentUserId, 'info', 'techId']);
            }

            if (fromTechId === toTechId) {
                return (
                    <h5 style={{
                        paddingTop: '15px'
                    }}>
                        To and From Techs cannot be the same
                    </h5>
                );
            }

            return (
                <div
                    style={{
                        minHeight: '150px',
                        paddingTop: '10px'
                    }}>
                    {transferMessageDisplay}
                    {transferErrorDisplay}
                    <TechInventorySwap
                        inventory={inventory}
                        fromTechId={fromTechId}
                        fromUserId={fromUserId}
                        currentUserId={currentUserId}
                        toTechId={toTechId}
                        techInventoryActions={techInventoryActions}
                        inventoryLoading={inventoryLoading}
                        inventoryLoadingFinished={inventoryLoadingFinished}
                    />
                </div>

            );

        }
        return null;
    }

    render() {
        const { techData, user, techInventoryActions } = this.props;

        if (techData.getIn(['techSearch', 'topMatch'])) {

            const fromUserId = techData.getIn(['techSearch', 'topMatch']);
            const inventoryLoading = techData.getIn(['techs', fromUserId, 'inventory', 'loading']);
            const inventoryLoadingFinished = techData.getIn(['techs', fromUserId, 'inventory', 'loadingFinished']);
            const shouldLoadInventory = !inventoryLoading && !inventoryLoadingFinished;

            if (fromUserId && shouldLoadInventory) {
                techInventoryActions.getTechInventoryStarted({
                    isSelf: false
                }, fromUserId);
            }
        }

        this.updateRecentSearches();

        const transferToContent = (
            <div><br />
                To Tech Id:
                <br />
                <TextField
                    className="wow-fst-input-container"
                    value={user.get('isFieldAdmin')
                        ? techData.getIn(['techSearch', 'transferToTechId'])
                        : techData.getIn([
                            'techs', user.get('userId'),
                            'info',
                            'techId'
                        ])}
                    disabled={!user.get('isFieldAdmin')}
                    hintText="To TechId"
                    fullWidth={true}
                    onChange={(e) => this.onToTechIdChange(e.target.value)} />
            </div>
        );

        return (
            <div>
                <h5 style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: '2em', justifyContent: 'center' }}>
                    <CompareArrowsIcon style={{ verticalAlign: 'middle', marginRight: 8 }} />
                    Equipment Transfer
                </h5>
                <div>
                    <form className="searchForm" onSubmit={this.findTech}>
                        <div className="row">
                            <span className="col s8">
                                From Tech Id:<br />
                                <TextField
                                    className="wow-fst-input-container"
                                    value={techData.getIn(['techSearch', 'searchCriteria'])
                                        ? techData.getIn(['techSearch', 'searchCriteria'])
                                        : ''}
                                    hintText="From Tech Id"
                                    fullWidth={true}
                                    onChange={(e) => this.onFromTechIdChange(e.target.value)} />

                            </span>
                            <span className="col s4">
                                <RaisedButton
                                    disabled={!techData.getIn(['techSearch', 'searchCriteria'])}
                                    label="Search"
                                    type="submit"
                                    primary={true}
                                    style={{
                                        margin: 12
                                    }} />
                            </span>
                        </div>
                    </form>
                </div>
                <div className="row neg-margin-top">
                    <span className="col s12">
                        {this.buildRecentSearches()}
                    </span>
                </div>
                {transferToContent}
                <div>
                    {this.generateContent()}
                </div>
                <Footer />
            </div>
        );
    }
}

TransferEquipmentPage.propTypes = {
    user: PropTypes.object,
    techData: PropTypes.object,
    userActions: PropTypes.object,
    techInventoryActions: PropTypes.object
};

function mapStateToProps(state) {
    return {
        workOrder: state.get('workOrder'),
        user: state.get('user'),
        techData: state.get('techData')
    };
}

function mapDispatchToProps(dispatch) {
    return {
        techInventoryActions: bindActionCreators(techInventoryActions, dispatch),
        statusActions: bindActionCreators(statusActions, dispatch),
        userActions: bindActionCreators(userActions, dispatch),
        push: bindActionCreators(dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(TransferEquipmentPage);


// WEBPACK FOOTER //
// ./src/containers/pages/TransferEquipmentPage.js